export const actionTypes = {
  GET_NOTIFICATION_LIST_PENDING: "GET_NOTIFICATION_LIST_PENDING",
  GET_NOTIFICATION_LIST_SUCCESS: "GET_NOTIFICATION_LIST_SUCCESS",
  GET_NOTIFICATION_LIST_ERROR: "GET_NOTIFICATION_LIST_ERROR",

  GET_NOTIFICATION_BY_ID_PENDING: "GET_NOTIFICATION_BY_ID_PENDING",
  GET_NOTIFICATION_BY_ID_SUCCESS: "GET_NOTIFICATION_BY_ID_SUCCESS",
  GET_NOTIFICATION_BY_ID_ERROR: "GET_NOTIFICATION_BY_ID_ERROR",

  ADD_NEW_NOTIFICATION_PENDING: "ADD_NEW_NOTIFICATION_PENDING",
  ADD_NEW_NOTIFICATION_SUCCESS: "ADD_NEW_NOTIFICATION_SUCCESS",
  ADD_NEW_NOTIFICATION_ERROR: "ADD_NEW_NOTIFICATION_ERROR",

  EDIT_NOTIFICATION_PENDING: "EDIT_NOTIFICATION_PENDING",
  EDIT_NOTIFICATION_SUCCESS: "EDIT_NOTIFICATION_SUCCESS",
  EDIT_NOTIFICATION_ERROR: "EDIT_NOTIFICATION_ERROR",

  DELETE_NOTIFICATION_PENDING: "DELETE_NOTIFICATION_PENDING",
  DELETE_NOTIFICATION_SUCCESS: "DELETE_NOTIFICATION_SUCCESS",
  DELETE_NOTIFICATION_ERROR: "DELETE_NOTIFICATION_ERROR",

  SEND_NOTIFICATION_PENDING: "SEND_NOTIFICATION_PENDING",
  SEND_NOTIFICATION_SUCCESS: "SEND_NOTIFICATION_SUCCESS",
  SEND_NOTIFICATION_ERROR: "SEND_NOTIFICATION_ERROR",

  SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_PENDING:
    "SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_PENDING",
  SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_SUCCESS:
    "SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_SUCCESS",
  SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_ERROR:
    "SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_ERROR",

  GET_NOTIFICATION_ACTIVITY_LIST_PENDING:
    "GET_NOTIFICATION_ACTIVITY_LIST_PENDING",
  GET_NOTIFICATION_ACTIVITY_LIST_SUCCESS:
    "GET_NOTIFICATION_ACTIVITY_LIST_SUCCESS",
  GET_NOTIFICATION_ACTIVITY_LIST_ERROR: "GET_NOTIFICATION_ACTIVITY_LIST_ERROR",

  UPDATE_CURRENT_PAGE: "UPDATE_CURRENT_PAGE",

  UPDATE_CURRENT_PAGE_OF_ACTIVITY_LOG: "UPDATE_CURRENT_PAGE_OF_ACTIVITY_LOG",

  UPDATE_ROWS_PER_PAGE: "UPDATE_ROWS_PER_PAGE",

  UPDATE_ROWS_PER_PAGE_OF_ACTIVITY_LOG: "UPDATE_ROWS_PER_PAGE_OF_ACTIVITY_LOG",

  UPDATE_SEARCH_FILTERS: "UPDATE_SEARCH_FILTERS",

  UPDATE_TABS: "UPDATE_TABS",
};

const initialState = {
  getNotificationListPending: false,
  getNotificationListSuccess: false,
  getNotificationListError: null,

  getNotificationByIdPending: false,
  getNotificationByIdSuccess: false,
  getNotificationByIdError: null,

  addNewNotificationPending: false,
  addNewNotificationSuccess: false,
  addNewNotificationError: null,

  editNotificationPending: false,
  editNotificationSuccess: false,
  editNotificationError: null,

  deleteNotificationPending: false,
  deleteNotificationSuccess: false,
  deleteNotificationError: null,

  sendNotificationPending: false,
  sendNotificationSuccess: false,
  sendNotificationError: null,

  sendNotificationForPublishedVideosPending: false,
  sendNotificationForPublishedVideosSuccess: false,
  sendNotificationForPublishedVideosError: null,

  getNotificationActivityListPending: false,
  getNotificationActivityListSuccess: false,
  getNotificationActivityListError: null,

  notificationList: [],
  activityLogList: [],
  notificationDataById: {},
  fields: {
    searchString: "",
  },
  currentPage: 1,
  rowsPerPage: { label: "10", value: 10 },
  currentPageOfActivityLog: 1,
  rowsPerPageOfActivityLog: { label: "10", value: 10 },
  activeSendNotificationTab: "Users",
};

export default function notificationManagement(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.GET_NOTIFICATION_LIST_SUCCESS:
    case actionTypes.GET_NOTIFICATION_LIST_PENDING:
    case actionTypes.GET_NOTIFICATION_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_NOTIFICATION_BY_ID_PENDING:
    case actionTypes.GET_NOTIFICATION_BY_ID_SUCCESS:
    case actionTypes.GET_NOTIFICATION_BY_ID_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.ADD_NEW_NOTIFICATION_PENDING:
    case actionTypes.ADD_NEW_NOTIFICATION_SUCCESS:
    case actionTypes.ADD_NEW_NOTIFICATION_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.EDIT_NOTIFICATION_PENDING:
    case actionTypes.EDIT_NOTIFICATION_SUCCESS:
    case actionTypes.EDIT_NOTIFICATION_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.DELETE_NOTIFICATION_PENDING:
    case actionTypes.DELETE_NOTIFICATION_SUCCESS:
    case actionTypes.DELETE_NOTIFICATION_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.SEND_NOTIFICATION_PENDING:
    case actionTypes.SEND_NOTIFICATION_SUCCESS:
    case actionTypes.SEND_NOTIFICATION_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_PENDING:
    case actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_SUCCESS:
    case actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_PENDING:
    case actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_SUCCESS:
    case actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_ERROR:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_ROWS_PER_PAGE_OF_ACTIVITY_LOG:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_CURRENT_PAGE_OF_ACTIVITY_LOG:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_SEARCH_FILTERS:
      return Object.assign({}, state, payload);

    case actionTypes.UPDATE_TABS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
